<template>
<div>
  <v-navigation-drawer
    v-model="drawer"
    absolute
    temporary
    disable-route-watcher
    right
    class="filters-nav"
  >
    <v-list class="filters">
      <v-subheader>
        <v-layout row>
          <v-flex xs6>
            <label>Filtros</label>
          </v-flex>
          <v-flex xs6 class="text-xs-right">
            <a @click="resetFilters" v-if="activeFiltersCount">Borrar todo</a>
          </v-flex>
        </v-layout>
      </v-subheader>
      <v-list-group class="active">
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title
              v-bind:class="{'': isFilterActive(['created__gte'])}"
              >
              Fecha creación
            </v-list-tile-title>
            <v-list-tile-sub-title v-if="isFilterActive(['created__gte'])">
              {{ activeFilters.created__gte }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-menu
          ref="created__gte"
          :close-on-content-click="false"
          v-model="created__gte"
          :nudge-right="5"
          full-width
          offset-y
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="activeFilters.created__gte"
            label="Desde"
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker
            :first-day-of-week="1"
            locale="es-es"
            v-model="activeFilters.created__gte"
            no-title scrollable
            @input="created__gte = false"
            flat></v-date-picker>
        </v-menu>
        <v-menu
          ref="created__lte"
          :close-on-content-click="false"
          v-model="created__lte"
          :nudge-right="5"
          full-width
          offset-y
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="activeFilters.created__lte"
            label="Hasta"
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker
            :first-day-of-week="1"
            locale="es-es"
            v-model="activeFilters.created__lte"
            no-title scrollable
            @input="created__lte = false"></v-date-picker>
        </v-menu>
      </v-list-group>
      <v-list-group class="active">
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title v-bind:class="{'': isFilterActive('status')}">
              Estado
            </v-list-tile-title>
            <v-list-tile-sub-title v-if="isFilterActive('status')">
              {{ getSelectedStatus() }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-for="status in masters.statuses"
          :key="status.id"
        >
          <v-list-tile-action class="checkbox-list">
            <v-checkbox
              v-model="activeFilters.status"
              :value="status.id"
              hide-details>
            </v-checkbox>
          </v-list-tile-action>
          <v-list-tile-title>{{ status.name }}</v-list-tile-title>
        </v-list-tile>
      </v-list-group>
      <v-list-group class="active">
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title
              v-bind:class="{'': isFilterActive('severity')}"
              >
              Severidad
            </v-list-tile-title>
            <v-list-tile-sub-title v-if="isFilterActive('severity')">
              {{ getSelectedSeverity() }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
          <v-list-tile
            v-for="severity in masters.severities"
            :key="severity.id">
            <v-list-tile-action class="checkbox-list">
              <v-checkbox
                v-model="activeFilters.severity"
                :value="severity.id">
              </v-checkbox>
            </v-list-tile-action>
            <v-list-tile-title>{{ severity.name }}</v-list-tile-title>
          </v-list-tile>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
  <v-toolbar flat class="pa-3">
    <v-text-field
      label="Busca por código, descripción, máquina y operador"
      append-icon="search"
      v-model="activeFilters.search"
      />
    <v-btn flat color="accent" @click.stop="drawer = !drawer">
      <v-badge color="primary" :value="activeFiltersCount">
        <span slot="badge">{{ activeFiltersCount }}</span>
        <span>Filtros</span>
      </v-badge>
    </v-btn>
   </v-toolbar>
  <data-table
    :total="totalResults"
    :items="incidents"
    :headers="headers"
    :loading="loading"
    :row-action="toDetailRoute"
    @paginationUpdated=paginationUpdated
    :page="currentPage"
    >
    <template slot="row" slot-scope="row" >
      <td>{{ row.item.code }}</td>
      <td>{{ row.item.description }}</td>
      <td>{{ row.item.operator }}</td>
      <td class="text-xs-right">
        {{ row.item.duration }}
        <span v-if="row.item.duration"> m.</span>
      </td>
      <td>{{ row.item.severity_display }}</td>
      <td>{{ row.item.status_display }}</td>
      <td>
        <v-chip :color="row.item.priority_color_name" text-color="white">
          {{ row.item.priority }}
        </v-chip>
      </td>
      <td>
        <template v-if="row.item.process">
            {{ row.item.process.code }}
        </template>
        <template v-else>---</template>
      </td>
      <td>
        <template v-if="row.item.machine">
            {{ row.item.machine.name }}
        </template>
        <template v-else>---</template>
      </td>
      <td>{{ row.item.created|format-date-time }}</td>
      <td>{{ row.item.modified|format-date-time }}</td>
    </template>
  </data-table>
  <incident-modal :drawer="drawer" :masters="masters"/>
</div>
</template>


<script>
import _ from 'lodash'

import api from '@/api/app'
import DataTable from '@/components/DataTable'
import IncidentModal from '@/partials/IncidentModal'
import formMixin from '@/mixins/formMixin'
import urlParamsMixin from '@/mixins/urlParamsMixin'
import mutationsMixin from '@/mixins/mutationsMixin'

export default {
  name: 'incidentsList',
  components: {DataTable, IncidentModal},
  mixins: [formMixin, urlParamsMixin, mutationsMixin],
  mounted () {
    this.loading = true

    let p1 = api.getIncidentStatuses().then(response => {
      this.masters.statuses = response
    })

    let p2 = api.getSeverities().then(response => {
      this.masters.severities = response
    })

    let p3 = api.getMachines().then(response => {
      this.masters.machines = response
    })

    Promise.all([p1, p2, p3]).then(() => {
      this.loading = false
    })
  },
  data () {
    return {
      drawer: false,
      headers: [
        {
          text: 'Código',
          align: 'left',
          sortable: true,
          value: 'code'
        },
        {
          text: 'Descripción',
          align: 'left',
          sortable: true,
          value: 'description'
        },
        {
          text: 'Operador',
          align: 'left',
          sortable: true,
          value: 'operator'
        },
        {
          text: 'Duracion',
          align: 'left',
          sortable: true,
          value: 'duration'
        },
        {
          text: 'Criticidad',
          align: 'left',
          sortable: true,
          value: 'severity'
        },
        {
          text: 'Estado',
          align: 'left',
          sortable: true,
          value: 'status'
        },
        {
          text: 'Prioridad',
          align: 'left',
          sortable: true,
          value: 'priority'
        },
        {
          text: 'Proceso',
          align: 'left',
          sortable: true,
          value: 'process.code'
        },
        {
          text: 'Máquina',
          align: 'left',
          sortable: true,
          value: 'machine.name'
        },
        {
          text: 'Creado',
          align: 'left',
          sortable: true,
          value: 'created'
        },
        {
          text: 'Modificado',
          align: 'left',
          sortable: true,
          value: 'modified'
        }
      ],
      incidents: [],
      requiredRules: [
        v => !!v || 'Campo obligatorio'
      ],
      masters: {statuses: []},
      selectedStatus: [],
      selectedSeverity: [],
      filters: ['status', 'severity', 'created__gte', 'created__lte'],
      activeFilters: {
        status: [],
        severity: []},
      params: {
        status: [],
        severity: [],
        page: null,
        page_size: null},
      pagination: {},
      currentPage: null,
      totalResults: 0,
      created__gte: false,
      created__lte: false
    }
  },
  computed: {
    activeFiltersCount () {
      let counter = 0
      this.filters.forEach(element => {
        if (this.isFilterActive(element)) {
          counter = counter + 1
        }
      })
      return counter
    }
  },
  methods: {
    setURLQueryParams () {
      Object.assign(this.params, this.activeFilters, this.pagination)
      Object.keys(this.params).forEach(key => {
        if (!this.params[key]) { delete this.params[key] }
      })
      this.$router.replace({ name: this.$route.name, query: this.params })
    },
    toDetailRoute (id) {
      this.$router.push({name: 'incident-detail', params: {'id': id}})
    },
    loadProcessTypeMaterials () {
      return api.getProcessTypeRawMaterials(this.activeFilters.process_type).then(response => {
        this.masters.materials = response
        this.getIncidents()
      })
    },
    processTypeChanged () {
      this.process.material = null
      this.loading = true

      this.loadProcessTypeMaterials(this.process.process_type).then(() => {
        this.loading = false
      })
    },
    getIncidents: _.debounce(function () {
      api.getIncidents(this.params).then(response => {
        this.incidents = response.results
        this.totalResults = response.count
      })
    }, 400),
    resetFilters () {
      this.activeFilters = {
        status: [],
        severity: [],
        created__gte: null,
        created__lte: null
      }
    },
    isFilterActive (filterName) {
      if (Object.keys(this.activeFilters).indexOf(filterName) === -1) {
        return false
      }
      if (Array.isArray(this.activeFilters[filterName])) {
        return this.activeFilters[filterName].length > 0
      }
      return this.activeFilters[filterName]
    },
    getStatusById (statusId) {
      return this.masters.statuses.find(function (element) {
        return element.id === statusId
      })
    },
    getSeverityById (severityId) {
      return this.masters.severities.find(function (element) {
        return element.id === severityId
      })
    },
    getSelectedStatus () {
      return this.selectedStatus.map(function (e) {
        return e.name
      }).join(',')
    },
    getSelectedSeverity () {
      return this.selectedSeverity.map(function (e) {
        return e.name
      }).join(',')
    },
    updateSelectedStatus () {
      this.selectedStatus = []

      let self = this

      this.activeFilters.status.map(function (e) {
        self.selectedStatus.push(self.getStatusById(e))
      })
    },
    updateSelectedSeverity () {
      this.selectedSeverity = []

      let self = this
      this.activeFilters.severity.map(function (e) {
        self.selectedSeverity.push(self.getSeverityById(e))
      })
    },
    paginationUpdated (pagination) {
      if (this.loading) {
        this.getUrlParams(this.filters, this.activeFilters)
      }
      this.pagination = pagination
      this.currentPage = this.pagination.page
      this.setURLQueryParams(this.filters, this.activeFilters)
      this.getIncidents()
    }
  },
  watch: {
    activeFilters: {
      handler () {
        if (this.loading) { return }

        this.updateSelectedStatus()
        this.updateSelectedSeverity()
        this.currentPage = 1
        this.setURLQueryParams()
        this.getIncidents()
      },
      deep: true
    },
    search (filter) {
      this.setURLQueryParams()
      this.getIncidents()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/IncidentList.vue